import React from 'react';

import {SkeletonItem} from 'src/components/skeleton';

import {Group} from '@pb/kit-component-group';


type Props = {
    totalCount: number,
};

export const GrantResourcesDetailsSkeleton = ({totalCount}: Props) => (
    <Group direction="v" gap="xs" alignItems="start">
        <SkeletonItem width={123} height={20}/>
        <br/>
        {new Array(totalCount).fill(0).map((_, index) => (
            <SkeletonItem key={index} width={123} height={20}/>
        ))}
    </Group>
);

